/*
 | Demo del autoinstalador (hero de la home). Tres escenas en bucle:
 | 1) el cursor elige la app  2) se rellenan los datos  3) la web aparece en línea.
 */
const wait = (ms) => new Promise((r) => setTimeout(r, ms));

// Textos: los pasa la vista ya traducidos (x-data="installerDemo(@js(…))"); sin ellos, en español.
export default function installerDemo(t = {}) {
    const text = {
        filling: "rellenando…",
        ready: "✓ listo para instalar",
        fields: ["Dominio", "Usuario", "Contraseña"],
        steps: ["Elige la app", "Rellena los datos", "Todo listo"],
        ...t,
    };

    return {
        scene: 1,
        picked: null,
        url: "cpanel.tuproyecto.com/instalador",
        appName: "WordPress",
        status: text.filling,
        cursorStyle: "transform:translate(360px,270px)",
        tilt: "",
        fields: [
            { label: text.fields[0], value: "", typing: false },
            { label: text.fields[1], value: "", typing: false },
            { label: text.fields[2], value: "", typing: false },
        ],
        steps: [
            { label: text.steps[0], duration: 4200 },
            { label: text.steps[1], duration: 4400 },
            { label: text.steps[2], duration: 4500 },
        ],
        done: 0,

        init() {
            if (matchMedia("(hover:hover)").matches) {
                addEventListener("mousemove", (e) => this.followMouse(e), { passive: true });
            }
            if (matchMedia("(prefers-reduced-motion: reduce)").matches) {
                this.scene = 3; this.done = 3; this.url = "tuproyecto.com";
                return;
            }
            this.run();
        },

        state(i) {
            if (i < this.done) return "done";
            if (i === this.scene - 1) return "on";
            return "idle";
        },

        followMouse(e) {
            const r = this.$refs.win.getBoundingClientRect();
            const dx = (e.clientX - (r.left + r.width / 2)) / innerWidth;
            const dy = (e.clientY - (r.top + r.height / 2)) / innerHeight;
            this.tilt = `transform:perspective(1400px) rotateY(${dx * 6}deg) rotateX(${-dy * 5}deg)`;
        },

        async type(field, text, ms) {
            field.value = ""; field.typing = true;
            for (let k = 1; k <= text.length; k++) { field.value = text.slice(0, k); await wait(ms); }
            field.typing = false;
        },

        async run() {
            // 1 · elegir app
            this.scene = 1; this.done = 0; this.picked = null;
            this.url = "cpanel.tuproyecto.com/instalador";
            this.cursorStyle = "transition:none;transform:translate(360px,270px)";
            await wait(500);
            const target = this.$refs.app0.getBoundingClientRect();
            const box = this.$refs.app0.closest(".absolute").getBoundingClientRect();
            this.cursorStyle = `transition:transform 1.1s cubic-bezier(.65,0,.35,1);transform:translate(${target.left - box.left + target.width * 0.55}px,${target.top - box.top + target.height * 0.6}px)`;
            await wait(1300);
            this.picked = 0;
            await wait(1600);

            // 2 · datos
            this.scene = 2; this.done = 1; this.status = text.filling;
            this.fields.forEach((f) => { f.value = ""; f.typing = false; });
            await wait(400);
            await this.type(this.fields[0], "tuproyecto.com", 60);
            await this.type(this.fields[1], "admin", 90);
            await this.type(this.fields[2], "••••••••••", 70);
            this.status = text.ready;
            await wait(1400);

            // 3 · en línea
            this.scene = 3; this.done = 2; this.url = "tuproyecto.com";
            await wait(4300);
            this.done = 3;
            await wait(1800);
            this.run();
        },
    };
}
